import React from 'react';
import DashSidebar from './DashSidebar';
import UpdateProducts from './UpdateProducts';
import { Link, useLocation } from 'react-router-dom';
import ExportProducts from './ExportProducts';
import UploadProduct from './UploadProduct';
import AddProduct from './AddProduct';

const DashProducts = () => {
    const location = useLocation();

    // Determine the active class based on the current route
    const getActiveClass = (route) => {
        return location.pathname === route ? "active" : "";
    };
    return (
        <>
            <section className="mt-3">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-2">
                            <DashSidebar activeClass={getActiveClass("/dashboard")} />
                        </div>
                        <div className="col-sm-10 light-border p-4">
                            <div className="control-btn-nav pb-3 row">
                                <div className="col-sm-9">
                                    <h3><b>Maitri Diamonds</b></h3>
                                </div>
                                <div className="col-sm-3 d-flex align-items-center">
                                    <Link className="ms-4 text-dark" data-bs-toggle="modal" data-bs-target="#exportModal">
                                        Export
                                    </Link>
                                    <ExportProducts />

                                    <Link className="ms-4 text-dark" data-bs-toggle="modal" data-bs-target="#importModal">
                                        Import
                                    </Link>
                                    <UploadProduct />

                                    <Link className="ms-4 btn btn__primary" data-bs-toggle="modal" data-bs-target="#addproductModal">
                                        Add Products
                                    </Link>
                                    <AddProduct />
                                </div>
                            </div>


                            <div className="content">
                                <UpdateProducts />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DashProducts